"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IOTV_LAMBDA_LOG_PREFIX = exports.getProjectPrefix = exports.Environment = void 0;
const env = process.env;
/** changed 2024 01 not to use destructuring for REACT_APP vars as React Native does not allow access except directly via process.env */
const default_region = env.AWS_DEFAULT_REGION ?? process.env.REACT_APP_AWS_DEFAULT_REGION;
const region = default_region;
const accountId = env.accountId ?? process.env.REACT_APP_AWS_ACCOUNT_ID;
const projectCode = env.projectCode ?? process.env.REACT_APP_PROJECT_CODE;
const appName = env.projectName ?? process.env.REACT_APP_PROJECT_NAME;
const stage = env.stage ?? process.env.REACT_APP_DEPLOYMENT_STAGE;
const projectName = env.projectName;
const deployReference = env.deployReference ?? 'deployReference not set';
const resolvedEnvironmentVariables = {
    default_region, region, accountId, projectCode, appName, stage
};
/** returns the iotv canonical project profrix plus hyphen like [projectCode]-[stage]- */
const getProjectPrefix = () => `${projectCode}-${stage}-`;
exports.getProjectPrefix = getProjectPrefix;
const Environment = { region, accountId, projectCode, projectName, stage, deployReference };
exports.Environment = Environment;
exports.IOTV_LAMBDA_LOG_PREFIX = '/iotv/lambda/';
